"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 26px;\n  margin-bottom: 26px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: ", ";\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: 20px;\n  font-size: 1.3rem;\n  text-decoration: underline;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: inline;\n  font-size: 1.3rem;\n  text-transform: uppercase;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var textColor = (0, _styledTheming.default)('mode', {
  homepoint: _Constant.Color.HOMEPOINT_LIGHT_BLUE,
  caliber: _Constant.Color.CALIBER_ACCENT_BLUE,
  figure: _Constant.Color.MOODY_BLURPLE
});
var bgColor = (0, _styledTheming.default)('mode', {
  homepoint: _Constant.Color.LIGHT_BACKGROUD_GREY,
  caliber: _Constant.Color.LIGHT_BACKGROUD_GREY,
  figure: _Constant.Color.LIGHT_BLURPLE
});

var Header = _styledComponents.default.h4(_templateObject(), textColor);

var Action = _styledComponents.default.a(_templateObject2(), textColor);

var Container = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.collapsed ? '7px 26px' : props.hasTopBorder ? '26px' : '10px 26px 5px';
}, function (props) {
  return props.collapsed ? "\n        animation-name: collapse-container;\n\n        @keyframes collapse-container {\n          from {\n            background-color: ".concat(bgColor, ";\n          }\n\n          to {\n            background-color: transparent;\n          }\n        }\n      ") : "\n        border-top: ".concat(props.hasTopBorder ? "solid ".concat(_Constant.Color.LINE_GREY) : "none", ";\n        animation-name: expand-container;\n\n        @keyframes expand-container {\n          from {\n            border-top-width: 0;\n            background-color: transparent;\n          }\n\n          to {\n            border-top-width: 1px;\n            background-color: ").concat(bgColor, ";\n          }\n        }\n      ");
});

var ExpandedContent = _styledComponents.default.div(_templateObject4());
/**
 * Accordion component to display collapsable sections.
 *
 * @todo - animate the accordion expansion
 */


var Accordion = function Accordion(_ref) {
  var collapsed = _ref.collapsed,
      headerText = _ref.headerText,
      actionText = _ref.actionText,
      onActionClick = _ref.onActionClick,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["collapsed", "headerText", "actionText", "onActionClick", "children"]);
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    collapsed: collapsed
  }, rest), /*#__PURE__*/_react.default.createElement(Header, null, headerText), /*#__PURE__*/_react.default.createElement(Action, {
    onClick: function onClick() {
      return onActionClick(collapsed);
    }
  }, actionText), !collapsed && /*#__PURE__*/_react.default.createElement(ExpandedContent, null, children));
};

Accordion.propTypes = {
  /** Whether the accordion is collapsed or not */
  collapsed: _propTypes.default.bool.isRequired,

  /** Header text */
  headerText: _propTypes.default.string.isRequired,

  /** Accordion action text */
  actionText: _propTypes.default.string.isRequired,

  /** Action text click event.  Passes the collapsed state. */
  onActionClick: _propTypes.default.func.isRequired,

  /** Children component to render when the accordion is expanded */
  children: _propTypes.default.node.isRequired,

  /** Tells whether or not to show a top border to the accordion element to avoid styling issues */
  hasTopBorder: _propTypes.default.bool
};
Accordion.defaultProps = {
  hasTopBorder: true
};
var _default = Accordion;
exports.default = _default;